import { ApiResponse } from '@/domain'
import { AccountReportView, ReportPeriodType } from '@/domain/reports/report'
import { backendApi } from '../backendApi'

export interface CreateReportViewPayload {
  name: string
  description?: string | null
  accountIds: string[]
  periodType: ReportPeriodType
}

export interface UpdateReportViewPayload {
  name?: string
  description?: string | null
  accountIds?: string[]
  periodType?: ReportPeriodType
}

export const reportsApi = {
  getAll: () =>
    backendApi
      .get<ApiResponse<AccountReportView[]>>('/api/v1/reports')
      .then((res) => res.data.data!),

  getById: (id: string) =>
    backendApi
      .get<ApiResponse<AccountReportView>>(`/api/v1/reports/${id}`)
      .then((res) => res.data.data!),

  create: (payload: CreateReportViewPayload) =>
    backendApi
      .post<ApiResponse<AccountReportView>>('/api/v1/reports', payload)
      .then((res) => res.data.data!),

  update: (id: string, payload: UpdateReportViewPayload) =>
    backendApi
      .put<ApiResponse<AccountReportView>>(`/api/v1/reports/${id}`, payload)
      .then((res) => res.data.data!),

  delete: (id: string) =>
    backendApi.delete<ApiResponse<void>>(`/api/v1/reports/${id}`).then((res) => res.data),
}

